<script setup>
//app\javascript\dashboard\components-next\message\bubbles\Text\Index.vue
import { computed, ref } from 'vue';
import BaseBubble from 'next/message/bubbles/Base.vue';
import FormattedContent from './FormattedContent.vue';
import AttachmentChips from 'next/message/chips/AttachmentChips.vue';
import TranslationToggle from 'dashboard/components-next/message/TranslationToggle.vue';
import { MESSAGE_TYPES } from '../../constants';
import { useMessageContext } from '../../provider.js';
import { useTranslations } from 'dashboard/composables/useTranslations';

// Contexto do Chatwoot
const { content, attachments, contentAttributes, messageType, inReplyTo } = useMessageContext();


console.groupEnd();

// Traduções
const { hasTranslations, translationContent } = useTranslations(contentAttributes);

// Estado local
const renderOriginal = ref(false);

// Computeds
const renderContent = computed(() => {
  const value = renderOriginal.value
    ? content.value
    : hasTranslations.value
      ? translationContent.value
      : content.value;


  return value;
});

const isTemplate = computed(() => {
  const result = messageType.value === MESSAGE_TYPES.TEMPLATE;
  return result;
});

const isEmpty = computed(() => {
  const result = !content.value && !attachments.value?.length;
  return result;
});

// Computed para classes de chamadas
const callBubbleClasses = computed(() => {
  if (messageType.value === 4) {
    // Chamada recebida (inbound) - cor teal
    return 'border bg-n-teal-2 border-n-teal-6';
  } else if (messageType.value === 5) {
    // Chamada feita (outbound) - cor iris/roxo
    return 'border bg-n-blue-6 border-n-blue-8';
  }
  return ''; // Padrão para outros tipos
});

const isCallMessage = computed(() => {
  return messageType.value === 4 || messageType.value === 5;
});

// Funções
const handleSeeOriginal = () => {
  renderOriginal.value = !renderOriginal.value;
};

</script>

<template>
  <BaseBubble 
    class="px-4 py-3" 
    :class="callBubbleClasses"
    data-bubble-name="text"
  >
    <div class="gap-3 flex flex-col">
      <span v-if="isEmpty" class="text-n-slate-11">
        {{ $t('CONVERSATION.NO_CONTENT') }}
      </span>

      <FormattedContent v-if="renderContent" :content="renderContent" />

      <TranslationToggle
        v-if="hasTranslations"
        class="-mt-3"
        :showing-original="renderOriginal"
        @toggle="handleSeeOriginal"
      />

      <AttachmentChips :attachments="attachments" class="gap-2" />

      <template v-if="isTemplate">
        <div
          v-if="contentAttributes.submittedEmail"
          class="px-2 py-1 rounded-lg bg-n-alpha-3"
        >
          {{ contentAttributes.submittedEmail }}
        </div>
      </template>
    </div>
  </BaseBubble>
</template>

<style>
p:last-child {
  margin-bottom: 0;
}
</style>